/**
 * @generated SignedSource<<5093822f6c771eb71a5a91eee48e4c0e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CoachMessagesRouteQuery$variables = {
  recipient: string;
  shouldFetchMessages: boolean;
};
export type CoachMessagesRouteQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"MessagingScreen_root">;
};
export type CoachMessagesRouteQuery = {
  response: CoachMessagesRouteQuery$data;
  variables: CoachMessagesRouteQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "recipient"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "shouldFetchMessages"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayName",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "photoURL",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slug",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "read",
  "storageKey": null
},
v7 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 999
  }
],
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v9 = [
  {
    "kind": "Literal",
    "name": "format",
    "value": "dddd DD MMM yyyy"
  }
],
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "content",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cursor",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "endCursor",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasNextPage",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v13 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 9999
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CoachMessagesRouteQuery",
    "selections": [
      {
        "args": [
          {
            "kind": "Variable",
            "name": "recipient",
            "variableName": "recipient"
          },
          {
            "kind": "Variable",
            "name": "shouldFetchMessages",
            "variableName": "shouldFetchMessages"
          }
        ],
        "kind": "FragmentSpread",
        "name": "MessagingScreen_root"
      }
    ],
    "type": "Root",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CoachMessagesRouteQuery",
    "selections": [
      {
        "condition": "shouldFetchMessages",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "alias": null,
            "args": [
              {
                "kind": "Variable",
                "name": "username",
                "variableName": "recipient"
              }
            ],
            "concreteType": "Thread",
            "kind": "LinkedField",
            "name": "thread",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Message",
                "kind": "LinkedField",
                "name": "lastMessage",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "format",
                        "value": "fromNow"
                      }
                    ],
                    "kind": "ScalarField",
                    "name": "createdAt",
                    "storageKey": "createdAt(format:\"fromNow\")"
                  },
                  (v1/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "author",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v3/*: any*/),
                  (v1/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Group",
                "kind": "LinkedField",
                "name": "group",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "membersCount",
                    "storageKey": null
                  },
                  (v1/*: any*/)
                ],
                "storageKey": null
              },
              (v1/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              {
                "alias": null,
                "args": (v7/*: any*/),
                "concreteType": "MessageConnection",
                "kind": "LinkedField",
                "name": "messages",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "MessageEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Message",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v1/*: any*/),
                          (v8/*: any*/),
                          {
                            "alias": "group",
                            "args": (v9/*: any*/),
                            "kind": "ScalarField",
                            "name": "createdAt",
                            "storageKey": "createdAt(format:\"dddd DD MMM yyyy\")"
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "User",
                            "kind": "LinkedField",
                            "name": "author",
                            "plural": false,
                            "selections": [
                              (v1/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "username",
                                "storageKey": null
                              },
                              (v2/*: any*/),
                              (v3/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v10/*: any*/),
                          {
                            "alias": "formattedDate",
                            "args": (v9/*: any*/),
                            "kind": "ScalarField",
                            "name": "createdAt",
                            "storageKey": "createdAt(format:\"dddd DD MMM yyyy\")"
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "direction",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      (v11/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v12/*: any*/)
                ],
                "storageKey": "messages(first:999)"
              },
              {
                "alias": null,
                "args": (v7/*: any*/),
                "filters": null,
                "handle": "connection",
                "key": "Messages_messages",
                "kind": "LinkedHandle",
                "name": "messages"
              }
            ],
            "storageKey": null
          }
        ]
      },
      {
        "alias": null,
        "args": (v13/*: any*/),
        "concreteType": "ThreadsConnection",
        "kind": "LinkedField",
        "name": "threads",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ThreadsEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Thread",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v1/*: any*/),
                  (v5/*: any*/),
                  (v6/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "User",
                    "kind": "LinkedField",
                    "name": "author",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "raw",
                            "value": true
                          }
                        ],
                        "kind": "ScalarField",
                        "name": "displayName",
                        "storageKey": "displayName(raw:true)"
                      },
                      (v1/*: any*/),
                      (v3/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Group",
                    "kind": "LinkedField",
                    "name": "group",
                    "plural": false,
                    "selections": [
                      (v4/*: any*/),
                      (v1/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v10/*: any*/),
                  {
                    "alias": "formattedDate",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "format",
                        "value": "D MMM"
                      }
                    ],
                    "kind": "ScalarField",
                    "name": "updatedAt",
                    "storageKey": "updatedAt(format:\"D MMM\")"
                  },
                  (v8/*: any*/)
                ],
                "storageKey": null
              },
              (v11/*: any*/)
            ],
            "storageKey": null
          },
          (v12/*: any*/)
        ],
        "storageKey": "threads(first:9999)"
      },
      {
        "alias": null,
        "args": (v13/*: any*/),
        "filters": null,
        "handle": "connection",
        "key": "Threads_threads",
        "kind": "LinkedHandle",
        "name": "threads"
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "me",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "unreadMessagesCounter",
            "storageKey": null
          },
          (v1/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "9d81ea7f05ed4bf7a87fcf1dacb356c1",
    "id": null,
    "metadata": {},
    "name": "CoachMessagesRouteQuery",
    "operationKind": "query",
    "text": "query CoachMessagesRouteQuery(\n  $recipient: String!\n  $shouldFetchMessages: Boolean!\n) {\n  ...MessagingScreen_root_2fTK2v\n}\n\nfragment Message_message on Message {\n  id\n  content\n  formattedDate: createdAt(format: \"dddd DD MMM yyyy\")\n  direction\n  author {\n    displayName\n    photoURL\n    id\n  }\n}\n\nfragment MessagesList_messages on MessageConnection {\n  edges {\n    cursor\n    node {\n      id\n      group: createdAt(format: \"dddd DD MMM yyyy\")\n      author {\n        id\n        username\n      }\n      ...Message_message\n    }\n  }\n}\n\nfragment Messages_thread on Thread {\n  ...ThreadHeader_thread\n  id\n  slug\n  read\n  messages(first: 999) {\n    edges {\n      node {\n        id\n        __typename\n      }\n      cursor\n    }\n    ...MessagesList_messages\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment MessagingScreen_root_2fTK2v on Root {\n  thread(username: $recipient) @include(if: $shouldFetchMessages) {\n    ...Messages_thread\n    id\n  }\n  threads(first: 9999) {\n    ...Threads_threads\n    edges {\n      node {\n        id\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  me {\n    unreadMessagesCounter\n    id\n  }\n}\n\nfragment ThreadCard_thread on Thread {\n  id\n  content\n  formattedDate: updatedAt(format: \"D MMM\")\n  read\n  slug\n  author {\n    id\n    displayName(raw: true)\n    photoURL\n  }\n  group {\n    name\n    id\n  }\n}\n\nfragment ThreadHeader_thread on Thread {\n  lastMessage {\n    createdAt(format: \"fromNow\")\n    id\n  }\n  author {\n    displayName\n    photoURL\n    id\n  }\n  group {\n    name\n    membersCount\n    id\n  }\n}\n\nfragment Threads_threads on ThreadsConnection {\n  edges {\n    node {\n      id\n      slug\n      read\n      author {\n        displayName(raw: true)\n        id\n      }\n      group {\n        name\n        id\n      }\n      ...ThreadCard_thread\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "37c48e442b1a9035a5660b2a3f9ef6c9";

export default node;
